import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          “Our interview process includes all of our partners, and that's intentional.” he says. “We
          want our partners to be as excited as we are about these teams because then, the degree to
          which those startups and partners can collaborate is much, much higher.”
        </p>

        <p className="chapter__paragraph">
          Caroline Chan, VP and General Manager of Intel’s Network Business Incubator Division and a
          member of the Lab’s Advisory Board, is a firm believer in the power of data. “Data always
          drives better decision-making,” she says. One of Chan’s goals is to help enterprises
          leverage the power of 5G to make the most of the data they collect.
        </p>
        <p className="chapter__paragraph">
          As for the challenges Bluewhite was facing, Chan and her team saw the solution as
          two-fold. The first addressed the issue of connectivity at the scale necessary for
          farmland. In 2021, the average U.S. farm spans 445 acres—roughly half the area of New
          York’s Central Park. “In the case of agriculture, Wi-Fi is going to have a difficult time
          managing a coverage area of that size. 5G becomes a very suitable way to do that,” Chan
          says.
        </p>
      </section>
    </>
  );
}

export default Chapter4;
